import { Component, EventEmitter, h,Prop, Event} from "@stencil/core";

@Component({
  tag: "ike-button-loader",
  styleUrl: "ike-button-loader.scss",
  shadow: false,
})
export class IkeButtonLoader { // button loader is using 3 bounced points loader
  @Prop() public type : string = "button";
  @Prop() public classNames : any = {};
  @Prop() public loading : boolean = true;
  @Prop() public disabled : boolean = false;
  @Prop() public dataCy = null;
  @Event() buttonClick: EventEmitter<any>;

  // need to pass color to set points background-color.
  // - default : shop main color
  // - grey-dark : according to the shop theme (Light or Dark)
  @Prop() public color : string = "default";

  render() {
    return (
      <button type={this.type} class={Object.assign(this.classNames,{"button" : true})} disabled={this.loading || this.disabled} onClick={() => !this.loading && this.buttonClick.emit()} data-cy={this.dataCy}>
        <slot/>
        {this.loading && <ike-loader color={this.color}></ike-loader>}
      </button>
    );
  }
}
